/**
 * COM-792 — drop a `;` typed straight after a closing `</script>` tag in BM
 * feature-content HTML.
 *
 * Third-party embeds get pasted into the `c_module*FeatureContent` attributes
 * with a trailing semicolon, as if the tag were a JS statement — e.g. product
 * 10078b's `c_module1FeatureContent` is
 * `<script src='https://cas.zma.gs/…/init.js'></script>;`. Rendered as HTML,
 * that `;` is a visible text node on the PDP. It is never meaningful content,
 * so it is stripped here for every product rather than fixed one BM entry at a
 * time.
 *
 * Only a `;` directly after `</script>` (whitespace allowed) is touched. A `;`
 * inside a script body comes BEFORE its `</script>`, and prose semicolons are
 * never immediately preceded by a closing script tag.
 */
export function stripStraySemicolonsAfterScripts(html: string): string {
  return html.replace(/(<\/script\s*>)\s*;/gi, "$1");
}
